import { useEntityUrl } from 'framework/routing';
import { EMPLOYEE_MY_PAGE_PARAMETER, EMPLOYEE_ROUTE_PATHS, WORKERS_PATH } from '../constants';
import { useIsMyProfile } from './useIsMyProfile';

export const useEmployeeUrl = () => {
  const { getSingleEntityUrl: getBaseSingleEntityUrl, ...rest } = useEntityUrl({
    baseLink: WORKERS_PATH,
    editPostfix: EMPLOYEE_ROUTE_PATHS.PERSONAL_LEGAL_EDIT,
  });
  const isMyProfile = useIsMyProfile();

  const getSingleEntityUrl = (id?: Nullable<string | number>) => {
    const currentId = id ?? (isMyProfile ? EMPLOYEE_MY_PAGE_PARAMETER : undefined);

    return getBaseSingleEntityUrl(currentId);
  };

  const getProfileUrl = (id?: Nullable<string>) => `${getSingleEntityUrl(id)}/${EMPLOYEE_ROUTE_PATHS.PERSONAL_LEGAL}`;

  const getCareerCapabilitiesUrl = (id?: Nullable<string>) =>
    `${getSingleEntityUrl(id)}/${EMPLOYEE_ROUTE_PATHS.CAREER_CAPABILITIES}`;

  const getProfileEditUrl = (id?: Nullable<string>) =>
    `${getSingleEntityUrl(id)}/${EMPLOYEE_ROUTE_PATHS.PERSONAL_LEGAL_EDIT}`;

  const getTimelineUrl = (id?: Nullable<string>) => `${getSingleEntityUrl(id)}/${EMPLOYEE_ROUTE_PATHS.TIMELINE}`;

  const getAccessLogUrl = (id?: Nullable<string>) => `${getSingleEntityUrl(id)}/${EMPLOYEE_ROUTE_PATHS.LOGS}`;

  const getTimelineSingleEntityUrl = (employeeId: string, timelineId: string) =>
    `${getTimelineUrl(employeeId)}/${timelineId}`;

  const getEmployeeAssignmentsUrl = (id?: Nullable<string>) =>
    `${getSingleEntityUrl(id)}/${EMPLOYEE_ROUTE_PATHS.ASSIGNMENTS}`;

  const getEmployeeBackgroundChecksUrl = (id?: Nullable<string>) =>
    `${getSingleEntityUrl(id)}/${EMPLOYEE_ROUTE_PATHS.BACKGROUND_CHECKS}`;

  const getEmployeePerformanceReportUrl = (id?: Nullable<string>) =>
    `${getSingleEntityUrl(id)}/${EMPLOYEE_ROUTE_PATHS.PERFORMANCE_REPORT}`;

  const getEmployeeDocumentsUrl = (id?: Nullable<string>) =>
    `${getSingleEntityUrl(id)}/${EMPLOYEE_ROUTE_PATHS.DOCUMENTS}`;

  const getEmployeeComplianceUrl = (id?: Nullable<string>) =>
    `${getSingleEntityUrl(id)}/${EMPLOYEE_ROUTE_PATHS.COMPLIANCE}`;

  const getEmployeeDocumentSignUrl = ({ id, path }: { id?: Nullable<string>; path: string }) =>
    `${getSingleEntityUrl(id)}/${EMPLOYEE_ROUTE_PATHS.POLICY_SIGN}/${path}`;

  return {
    ...rest,
    getSingleEntityUrl,
    getCareerCapabilitiesUrl,
    getProfileUrl,
    getProfileEditUrl,
    getTimelineUrl,
    getTimelineSingleEntityUrl,
    getAccessLogUrl,
    getEmployeeAssignmentsUrl,
    getEmployeeBackgroundChecksUrl,
    getEmployeePerformanceReportUrl,
    getEmployeeDocumentsUrl,
    getEmployeeComplianceUrl,
    getEmployeeDocumentSignUrl,
  };
};
